import { render, staticRenderFns } from "./Detail-Services.vue?vue&type=template&id=ebf88966"
import script from "./Detail-Services.vue?vue&type=script&lang=js"
export * from "./Detail-Services.vue?vue&type=script&lang=js"
import style0 from "./Detail-Services.vue?vue&type=style&index=0&id=ebf88966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports